/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_EmailInputs */

const en_support_email = /** @type {(inputs: Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email support`)
};

const id_support_email = /** @type {(inputs: Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email bantuan`)
};

/**
* | output |
* | --- |
* | "Email support" |
*
* @param {Support_EmailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_email = /** @type {((inputs?: Support_EmailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_EmailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_email(inputs)
	return en_support_email(inputs)
});